import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import Tour from "reactour";
import { IEmpresa, newEmpresa } from "../../../model";
import { AppStore } from "../../../stores/AppStore";
import { ResultadoStore } from "../../../stores/resultados/ResultadoStore";
import { Pager } from "../../utils/Pager";
import NaoContestadosTable from "./nao_contestados_table";

interface Props {
  handleContestarLote: () => void;
}

interface State {
  handleContestarLote: () => void;
  isTourOpen: boolean;
}

@observer
export default class NaoContestados extends React.Component<Props, State> {

  obs = observable({
    modelo: "ENTRADA" as string,
    selectedPeriod: [new Date(), new Date()] as any,
    selectedEmpresa: newEmpresa() as IEmpresa,
  })

  constructor(props) {
    super(props);

    this.state = {
      handleContestarLote: props.handleContestarLote,
      isTourOpen: false,
    };

  }

  componentDidMount() {
    AppStore.setTitle("Resultados de Cálculos");
    // this.obs.selectedPeriod = AppStore.obs1.selectedPeriod;
    // this.obs.selectedEmpresa = AppStore.obs1.selectedEmpresa;

    if (ResultadoStore.obs.result_memoria_count > 0 && !ResultadoStore.obs.filterErrors) {
      this.openTour();
      ResultadoStore.obs.selectedResultadosTab = "memoria";
    }
  }

  closeTour = () => {
    this.setState({ isTourOpen: false });
  };

  openTour = () => {
    this.setState({ isTourOpen: true });
  };

  handlePageChangeProduto(page: number) {
    ResultadoStore.obs.pageProduto = page;
    ResultadoStore.handleResultMemoriaFiltered(page, "PA");
  }

  render() {
    let results = ResultadoStore.obs.result_memoria;
    const { isTourOpen } = this.state;

    const tourConfig = [
      {
        selector: '[data-tut="nao__calculados"]',
        content: (
          <>
            Você tem itens que não foram calculados.
            <br />
            <br />
            Precisa atribuir o <b>PRODUTO</b> de cada item e contestar.
            <br />
            <br />
            Para salvar esta contestação basta marcar a checkbox Salvar
            Contestação.
            <br />
            <br />
            Se optar por salvar este item, na próxima importação não será
            necessário contestá-lo novamente.
            <br />
            <br />
            Você pode visualizar suas contestações salvas em Memória de
            Cálculos.
            <br />
            <br />
          </>
        ),
      },
    ];

    return (
      <>
        <Tour
          onRequestClose={this.closeTour}
          steps={tourConfig}
          isOpen={isTourOpen}
          maskClassName="mask"
          className="helper tour-memoria"
          rounded={5}
        />

        <NaoContestadosTable
          handleContestarLote={this.state.handleContestarLote.bind(this)}
          empresa={this.obs.selectedEmpresa}
          modelo={this.obs.modelo}
          items={results}
          data={this.obs.selectedPeriod}
        />

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
            <Pager
              currentPage={ResultadoStore.obs.pageProduto}
              totalCount={ResultadoStore.obs.result_memoria_count}
              onPageChange={(page) => this.handlePageChangeProduto(page)}
              pageSize={15}
            />
        </div>
      </>
    );
  }
}
